"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./MinicardStyles.scss");
const Minicard = ({ card }) => {
    return (react_1.default.createElement("div", { className: "MiniCard" },
        react_1.default.createElement("img", { src: card.image, alt: card.title }),
        react_1.default.createElement("div", { className: "minicard-content" },
            react_1.default.createElement("span", null, card.title),
            react_1.default.createElement("span", null, card.desc))));
};
exports.default = Minicard;
